// Licence Auditu z portálu BOZP-SOFTWARE (krok 3, rozhodnutí uživatele 2026-11-01).
// Stav licence načítá supabase-layer.js (window.__licence, událost bozp-licence).
// Tady: proužek nad obsahem (zkušební verze / jen ke čtení), režim jen ke čtení
// (window.__licenceReadOnly — zápisy blokuje supabase-layer, rozhoduje i databáze)
// a obsazení licencí pro Uživatele a role.
import { esc, realRole, showToast, state } from './state.js';

function licenceRow(){ return window.__licence ? window.__licence.get() : null; }
function portalUrl(){ return (window.__licence && window.__licence.portalUrl) || 'https://bozp-software.cz'; }

// Aktivní (nepozastavení) uživatelé organizace.
function activeUserCount(){
  var n = 0;
  (state.roles || new Map()).forEach(function(r){ if(r && !r.blokovan) n++; });
  return n;
}

// null = bez řádku licence (aplikace nic neomezuje, rozhoduje databáze).
function licenceInfo(){
  var l = licenceRow();
  if(!l) return null;
  var now = Date.now();
  var until = l.plati_do ? Date.parse(l.plati_do) : null;
  var valid = (l.stav === 'zkusebni' || l.stav === 'aktivni') && !(until != null && until <= now);
  var used = activeUserCount();
  var over = valid && l.pocet != null && !!state.rolesReady && used > l.pocet;
  return {
    stav: l.stav, pocet: l.pocet, until: until, used: used, valid: valid, over: over,
    readOnly: !valid || over,
    daysLeft: until != null ? Math.max(0, Math.ceil((until - now) / 864e5)) : null
  };
}
function isReadOnly(){ var i = licenceInfo(); return !!(i && i.readOnly); }
window.__licenceReadOnly = isReadOnly;

// Akce, která zapisuje (zahájení auditu…): v režimu jen ke čtení hláška a false.
function guardWrite(){
  if(!isReadOnly()) return true;
  showToast('Aplikace je jen ke čtení — předplatné není aktivní.');
  return false;
}

// Úložiště organizace: {used, limit, pct} | null (bez limitu nebo neznámé využití).
function storageInfo(){
  var st = window.__storage ? window.__storage.get() : null;
  if(!st || st.limit == null || st.used == null) return null;
  return {used: st.used, limit: st.limit, pct: st.limit ? st.used / st.limit : 0};
}
function fmtGb(b){ return (b / 1073741824).toLocaleString('cs-CZ', {maximumFractionDigits: 1}) + ' GB'; }
// Hláška pro neúspěšné nahrání (plné úložiště má vlastní text).
function uploadErrorText(e, fallback){
  return (e && e.code === 'storage_full' && e.message) ? e.message : (fallback || 'Nahrání se nezdařilo.');
}

function daysLabel(n){ return n + (n === 1 ? ' den' : (n >= 2 && n <= 4) ? ' dny' : ' dní'); }

function updateLicenceBanner(){
  var el = document.getElementById('licenceBanner');
  if(!el) return;
  var i = licenceInfo();
  var admin = realRole() === 'administrator';
  var html = '';
  if(i && !i.valid){
    html = '<span><b>Předplatné není aktivní</b> — aplikace je jen ke čtení. Data můžete prohlížet a exportovat.</span>' +
      (admin ? '<a class="btn btn-sm btn-primary" href="' + esc(portalUrl()) + '">Aktivovat</a>' : '');
  } else if(i && i.over){
    html = '<span><b>Víc uživatelů (' + i.used + ') než licencí (' + i.pocet + ')</b> — aplikace je jen ke čtení. ' +
      (admin ? 'Přikupte licence, nebo někomu licenci odeberte v portálu.' : 'Počet uživatelů musí upravit administrátor.') + '</span>' +
      (admin ? '<button class="btn btn-sm" onclick="App.setView(\'users\')">Uživatelé</button>' : '');
  } else if(i && i.stav === 'zkusebni' && i.daysLeft != null){
    html = '<span>Zkušební verze — zbývá <b>' + daysLabel(i.daysLeft) + '</b>.</span>' +
      (admin ? '<a class="btn btn-sm" href="' + esc(portalUrl()) + '">Aktivovat předplatné</a>' : '');
  }
  var st = storageInfo();
  if(!html && st && st.pct >= 1){
    html = '<span><b>Úložiště je plné</b> (' + fmtGb(st.used) + ' z ' + fmtGb(st.limit) + ') — nové fotky a přílohy nejde nahrát. ' +
      (admin ? 'Přikupte místo v portálu, nebo smažte staré audity a přílohy.' : 'Místo musí přikoupit administrátor.') + '</span>' +
      (admin ? '<a class="btn btn-sm btn-primary" href="' + esc(portalUrl()) + '/ucet/">Přikoupit místo</a>' : '');
  } else if(!html && st && st.pct >= 0.9 && admin){
    html = '<span>Úložiště je skoro plné — využito <b>' + fmtGb(st.used) + ' z ' + fmtGb(st.limit) + '</b>.</span>' +
      '<a class="btn btn-sm" href="' + esc(portalUrl()) + '/ucet/">Přikoupit místo</a>';
  }
  el.style.display = html ? 'flex' : 'none';
  el.classList.toggle('licence-readonly', !!(i && i.readOnly));
  el.innerHTML = html;
}
window.addEventListener('bozp-licence', updateLicenceBanner);

// Obsazení licencí pro Uživatele a role: {used, total|null}, null = bez licence.
function seatInfo(){
  var i = licenceInfo();
  if(!i) return null;
  return {used: i.used, total: i.stav === 'zkusebni' ? null : i.pocet, canAdd: i.valid && (i.pocet == null || i.stav === 'zkusebni' || i.used < i.pocet)};
}

export { guardWrite, isReadOnly, licenceInfo, portalUrl, seatInfo, storageInfo, updateLicenceBanner, uploadErrorText };
